export const Logo = () => (
  <div className="logo-block">
    <a href="!#">
      <img src="images/crm/logo.svg" alt="" />
    </a>
  </div>
);
